import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import CropTool from './CropTool';
import { connect } from 'react-redux';
import { updateFiles } from '../../ducks';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';

const mapStateToProps = (state, props) => {
	return {
		user: state.auth.user,
	};
};

const actions = {
	updateFiles,
};
// import './index.css';

// export class BootBox extends React.Component {
// }

class CropModal extends Component {
	state = {
		croppedURL: null,
	};

	updateCropUrl = data => {
		this.setState({ croppedURL: data });
	};

	save = () => {
		console.log('croppedURL:', this.state.croppedURL);

		let jsonData = {
			user_id: this.props.user._id,
		};
		let that = this;
		let updateFiles = this.props.updateFiles;
		let description = 'profile_pic_cropped';
		let key = 'profile_pic_id_fk';
		let api = '/api/user_saveFile';
		const formData = new FormData();
		formData.append('fileupload', that.state.croppedURL, that.props.user._id + '_croppedpic.jpg');
		formData.append('description', description);
		formData.append('key', key);

		axios
			.post('/api/upload_file', formData, {})
			.then(res => {
				console.log("what's the res:", res);
				that.setState({ profile_pic_path: '/' + res.data.path });
				jsonData.file_id = res.data._id;
				jsonData.key = key;
				/*axios.post(api, jsonData, {}).then(res => {
					axios.get('/api/getUsersFiles').then(function(response) {
						updateFiles(response.data);
						that.props.onNoClick();
					});
				});*/
				that.props.updatePicPath(res.data.path);
				that.props.onNoClick();
			})
			.catch(error => {
				NotificationManager.error('Please choose a smaller sized file', 'File too large to upload');
			});
	};

	dataURLtoFile(dataurl, filename) {
		let arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);

		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], filename, { type: mime });
		//this.setState({croppedImage: croppedImage })
	}

	render() {
		if (this.props.image === undefined) return null;

		return (
			<Modal className="bootbox-modal" show={this.props.show} onHide={this.props.onClose}>
				<Modal.Body>
					<CropTool image={this.props.image} save={this.state.save} updateCropUrl={this.updateCropUrl} />
				</Modal.Body>
				<Modal.Footer className="bootbox-modal-footer">
					<Button className="btn btn-secondary" onClick={() => this.props.onNoClick()}>
						{this.props.cancelText ? this.props.cancelText : 'No'}
					</Button>
					<Button className="btn btn-success" onClick={() => this.save()}>
						{this.props.confirmText ? this.props.confirmText : 'Yes'}
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default connect(mapStateToProps, actions)(CropModal);
